import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { SortScene } from "./SortScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.MailDelivery;
        this.mainScene = SortScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "MailDelivery.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "MailDelivery.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "";
    }
}



// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/scenes/IntroductionScene.ts